var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSave = function SvgSave(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.016 10.659H3.507V3.553h17.509v7.106zm-5.248 17.788c-2.903 0-5.248-2.392-5.248-5.341s2.345-5.341 5.248-5.341 5.248 2.392 5.248 5.341c0 2.949-2.345 5.341-5.248 5.341zM24.523 0H3.507C1.58 0 0 1.602 0 3.553v24.894C0 30.421 1.579 32 3.507 32H28.03c1.927 0 3.507-1.602 3.507-3.553V7.106L24.524 0z"
  })));
};
export default SvgSave;